import { CloseSvg, SummaryDashboardIcon } from "../../assets/icons/Icons";


const ScheduleSummary = ({ onClose, scheduleData }) => {

    return (
        <div className="summary-dashboard">
            <div className="summary-dashboard-header">
                <div className="d-flex gap-1">
                    <div className="gs-header-icon">
                        <SummaryDashboardIcon />
                    </div>
                    <div className="gs-header-text">Schedule Summary</div>
                </div>
                <div>
                    <div
                        className="gs-header-close-icon"
                        onClick={onClose}
                    >
                        <CloseSvg color={"#F0F0F0"} />
                    </div>
                </div>
            </div>
            <div className="summary-dashboard-content">
                <div className="sd-orders-count">
                    <div className="sd-orders-type">
                        <div className="sd-heading">
                            <span>{scheduleData.scheduleSummary?.scheduledOrdersCount || 0}</span>
                            <span>/</span>
                            <span className="heading-dull">{scheduleData.scheduleSummary?.evaluatedOrdersCount || 0}</span>
                        </div>
                        <div className="sd-sub-heading">Scheduled Orders</div>
                    </div>
                    <div className="sd-orders-type">
                        <div className="sd-heading">
                            <span>{scheduleData.scheduleSummary?.scheduledCurrentOrdersCount || 0}</span>
                        </div>
                        <div className="sd-sub-heading">Current Orders</div>
                    </div>
                    <div className="sd-orders-type">
                        <div className="sd-heading">
                            <span>{scheduleData.scheduleSummary?.scheduledPendingOrdersCount || 0}</span>
                        </div>
                        <div className="sd-sub-heading">Pending Orders</div>
                    </div>
                </div>
                <div className="sd-orders-count">
                    <div className="sd-orders-type">
                        <div className="sd-heading">
                            <img
                                src={require("../../assets/raw/HighPriorityIcon.svg").default}
                                alt=""
                            />
                            <span>{scheduleData.scheduleSummary?.asapOrderCount || 0}</span>
                        </div>
                        <div className="sd-sub-heading">ASAP Priority</div>
                    </div>
                    <div className="sd-orders-type">
                        <div className="sd-heading heading-with-icon">
                            <img
                                src={
                                    require("../../assets/raw/MediumPriorityIcon.svg").default
                                }
                                alt=""
                            />
                            <span>{scheduleData.scheduleSummary?.highOrderCount || 0}</span>
                        </div>
                        <div className="sd-sub-heading">High Priority</div>
                    </div>
                    <div className="sd-orders-type">
                        <div className="sd-heading heading-with-icon">
                            <img
                                src={require("../../assets/raw/Normal.svg").default}
                                alt=""
                            />
                            <span>{scheduleData.scheduleSummary?.normalOrderCount || 0}</span>
                        </div>
                        <div className="sd-sub-heading">Normal Priority</div>
                    </div>
                </div>
                <div className="sd-content">
                    <div className="sd-content-header">Coverage and Data</div>
                    <div className="sd-content-body">
                        <div className="sd-content-item">
                            <div className="sd-content-item-text">Area Imaged</div>
                            <div className="sd-content-item-value">
                                <span className="item-value-text">12,503</span>
                                <span className="item-value-unit">sq. km.</span>
                            </div>
                        </div>
                        <div className="sd-content-item">
                            <div className="sd-content-item-text">Data Generated</div>
                            <div className="sd-content-item-value">
                                <span className="item-value-text">12.45</span>
                                <span className="item-value-unit">TB</span>
                            </div>
                        </div>
                        <div className="sd-content-item">
                            <div className="sd-content-item-text">Data Downlink</div>
                            <div className="sd-content-item-value">
                                <span className="item-value-text downlink-value-text">
                                    8.45
                                </span>
                                <span className="item-value-unit">TB</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="sd-content">
                    <div className="sd-content-header-with-subheading">
                        <span>Missed Opportunities</span>
                        <span className="header-subheading">due to</span>
                    </div>
                    <div className="sd-content-body">
                        <div className="sd-content-item">
                            <div className="sd-content-item-text">Power</div>
                            <div className="sd-content-item-value">
                                <span className="item-value-text">12</span>
                                <span className="item-value-green">15.8%</span>
                            </div>
                        </div>
                        <div className="sd-content-item">
                            <div className="sd-content-item-text">Thermal</div>
                            <div className="sd-content-item-value">
                                <span className="item-value-text">4</span>
                                <span className="item-value-orange">4.5%</span>
                            </div>
                        </div>
                        <div className="sd-content-item">
                            <div className="sd-content-item-text">Avl. Storage</div>
                            <div className="sd-content-item-value">
                                <span className="item-value-text">2</span>
                                <span className="item-value-green">15.8%</span>
                            </div>
                        </div>
                        <div className="sd-content-item">
                            <div className="sd-content-item-text">ADCS Agility</div>
                            <div className="sd-content-item-value">
                                <span className="item-value-text">4</span>
                                <span className="item-value-green">15.8%</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ScheduleSummary;